import Grid2 from "@mui/material/Unstable_Grid2";
import {Typography} from "@mui/material";
import React from "react";

interface SimpleYTEmbedProps {
    title: string;
    url: string
}

export function SimpleYTEmbed({title, url}: SimpleYTEmbedProps) {
    return <Grid2 container>
        <Grid2 xs={12} md={12} spacing={2}>
            <Typography variant="h6">{title}</Typography>
        </Grid2>
        <Grid2 xs={12} md={12}>
            <iframe width="100%" height="auto"
                    src={url}
                    title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen>

            </iframe>
        </Grid2>

    </Grid2>

}